import { render } from "./dialog-role.vue?vue&type=template&id=4eea3f68&ts=true"
import script from "./dialog-role.vue?vue&type=script&lang=ts"
export * from "./dialog-role.vue?vue&type=script&lang=ts"

import "./dialog-role.vue?vue&type=style&index=0&id=4eea3f68&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__